import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function PaidRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  // Free users must never access paid-only routes like /tokens.
  const plan = user.subscription_plan || "free";
  if (plan !== "free") return children;
  // otherwise redirect to pricing to encourage upgrade
  return <Navigate to="/pricing" replace />;
}
